import React, { cloneElement, isValidElement } from 'react';

import { withVerticalSpacing } from '../../hocs/withVerticalSpacing/withVerticalSpacing';

import {
    StyledContainer,
    StyledPromoTileLayout,
} from './PromoTileLayout.styled';
import { PromoTileLayoutProperties } from './PromoTileLayout.types';

const MAX_WIDTH = {
    1: 720,
    2: 1080,
    3: 1440,
};

const PromoTileLayoutComponent = ({
    id,
    content,
    isSlim = false,
}: PromoTileLayoutProperties): React.ReactElement => {
    const numberOfChildren = content.length;
    const numberOfColumns = getNumberOfColumns(numberOfChildren);
    const mappedContent = content.map(element => {
        /* istanbul ignore next */
        if (!isValidElement<{ schema: { isSlim: boolean } }>(element))
            return element;

        const newSchema = {
            ...element.props.schema,
            isSlim,
        };

        return cloneElement(element, {
            ...element.props,
            schema: newSchema,
        });
    });

    return (
        <StyledContainer id={id ?? 'promo-tiles'}>
            <StyledPromoTileLayout
                $numberOfColumns={numberOfColumns}
                $maxWidth={MAX_WIDTH[numberOfColumns]}
                data-testid="promo-tile-layout"
            >
                {mappedContent}
            </StyledPromoTileLayout>
        </StyledContainer>
    );
};

export const PromoTileLayout = withVerticalSpacing(PromoTileLayoutComponent);

export const getNumberOfColumns = (numberOfChildren: number) =>
    numberOfChildren >= 3 && numberOfChildren % 2 !== 0
        ? 3
        : numberOfChildren % 2 === 0
          ? 2
          : 1;
